"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeepLinkProvider = exports.DeepLinkContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const AppLinking_1 = require("../AppLinking");
exports.DeepLinkContext = react_1.default.createContext(null);
const DeepLinkProvider = ({ children }) => {
    const [url, setUrl] = react_1.default.useState(null);
    const [clientOverride, setClientOverride] = react_1.default.useState(null);
    const [ready, setReady] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        const sub = react_native_1.DeviceEventEmitter.addListener('deepLink.received', (url) => {
            setDeepLink(url);
        });
        return () => sub.remove();
    }, []);
    const setDeepLink = async (incomingUrl) => {
        if (!incomingUrl) {
            setUrl(null);
            setClientOverride(null);
            return;
        }
        const parsedClient = (() => {
            try {
                const parsed = new URL(AppLinking_1.AppLinking.trimHost(incomingUrl, AppLinking_1.AppLinking.prefixes));
                if (parsed.searchParams.has('mode')) { // Firebase auth link
                    return null;
                }
                return parsed.searchParams.get('client');
            }
            catch (e) {
                return null;
            }
        })();
        if (incomingUrl.includes('mode=resetPassword')) {
            setReady(true);
        }
        setUrl(incomingUrl);
        setClientOverride(parsedClient ?? null);
    };
    const markReady = () => setReady(true);
    const consume = async () => {
        setUrl(null);
        setClientOverride(null);
        setReady(false);
    };
    return ((0, jsx_runtime_1.jsx)(exports.DeepLinkContext.Provider, { value: {
            deepLink: {
                url,
                clientOverride,
                ready
            },
            setDeepLink,
            markReady,
            consume
        }, children: children }));
};
exports.DeepLinkProvider = DeepLinkProvider;
